module.exports = __webpack_public_path__ + "img/big_1_29.9c791753.png";